import React from 'react'
import { css } from 'glamor'
import { Loader } from '../../components/core/Loader'
import { useQueryGetInstallationStatus } from '../../software-notification/queries'

export const SoftwareUpdateRibbon = () => {
    const { data: installationStatus} = useQueryGetInstallationStatus({
        refetchInterval: 1000 * 60 * 3
    })

    if (installationStatus !== 'InstallationStarted') {
        return null
    }

    return (
        <div
            {
                ...css({
                    display: 'flex',
                    gap: '20px',
                    padding: '8px 10px',
                    background: 'white',
                    border: '1px solid transparent',
                    borderRadius: '40px',
                    marginBottom: '20px',
                    justifyContent: 'center'
                })
            }
        >
            <div>
                <Loader />
            </div>
            <div>
                Software update is progressing...
            </div>
        </div>
    )
}